import {
  FileText,
  Download,
  Layers,
  FileCheck,
  List,
  BookOpen,
  Hash,
  Search,
  Upload,
} from "lucide-react";

const steps = [
  { icon: FileText, label: "Notice of Appeal" },
  { icon: Download, label: "Download documents" },
  { icon: Layers, label: "Combine PDFs" },
  { icon: FileCheck, label: "Format cover page" },
  { icon: List, label: "Build TOC" },
  { icon: BookOpen, label: "Create CPLR 5531 statement" },
  { icon: Hash, label: "Paginate" },
  { icon: Search, label: "Review" },
  { icon: Upload, label: "File" },
];

export default function ProblemSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-problem-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        THE PROBLEM
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 max-w-xl leading-tight">
        Preparing a Record on Appeal is slow, manual, and expensive
      </h1>

      <div className="flex-1 flex flex-col md:flex-row gap-4 md:gap-8 lg:gap-12 min-h-0">
        <div className="flex-1 flex flex-col justify-center gap-3">
          {[
            "Law firms still rely on manual assembly to prepare the record on appeal for appellate courts",
            <>
              Preparing a Record on Appeal can take{" "}
              <span className="font-semibold text-slate-900">
                days and sometimes weeks
              </span>
            </>,
            <>
              Clients often pay{" "}
              <span className="font-semibold text-slate-900">
                $5,000 &ndash; $20,000 for each record on appeal
              </span>
            </>,
            "The workflow is repetitive, formatting-heavy, and error-prone",
            "No modern, software-first default solution exists",
          ].map((text, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-[7px] shrink-0" />
              <p className="text-sm text-slate-600 font-body leading-relaxed">
                {text}
              </p>
            </div>
          ))}
        </div>

        <div className="w-full md:w-[240px] shrink-0 flex flex-col items-center justify-center gap-0.5 overflow-hidden">
          <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-2 font-body">
            Current Workflow
          </div>
          {steps.map((step, i) => (
            <div key={i} className="flex flex-col items-center w-full">
              <div className="flex items-center gap-2 bg-slate-50 rounded px-2.5 py-1 w-full border border-slate-200">
                <step.icon className="h-3 w-3 text-slate-400 shrink-0" />
                <span className="text-sm text-slate-600 font-body truncate">
                  {step.label}
                </span>
              </div>
              {i < steps.length - 1 && (
                <div className="w-px h-1.5 bg-slate-300" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
